export default __webpack_public_path__ + "static/media/alan_bot.cecb8cca.png";